export default {
  getLocale: state => state.locale,
  getDefaultPath: state => state.defaultPath,
  getOverheadLayout: state => state.interface.overheadLayout,
  getSizesConfig: state => state.interface.sizesConfig,
  getWindowsList: state =>
    state.interface.desktop.concat(state.interface.overheadLayout)
};
